var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
    click: function click() {
      return _vm.$emit('click');
    }
  } : {}), [_vm._t("icon"), _c('v-list-item-content', [!_vm.small ? _c('v-list-item-subtitle', {
    staticClass: "text-xs"
  }, [!_vm.hasActionListener ? _c('tooltip', {
    attrs: {
      "text": _vm.item.statusReadable
    }
  }, [_c('v-avatar', {
    staticClass: "mr-1 white--text",
    attrs: {
      "color": _vm.item.statusColor,
      "elevation": 0,
      "size": "8"
    }
  })], 1) : _vm._e(), _vm.item.subTotal ? _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.item.subTotal, _vm.item.currency)) + " ")]) : _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(0, _vm.item.currency)) + " ")]), _vm.item.date && _vm.item.isOverdue ? _c('v-chip', {
    attrs: {
      "color": "error",
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.item.date)) + " ")]) : _vm._e()], 1) : _vm._e(), _c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.number) + " ")])]), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.seller ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.seller")) + " " + _vm._s(_vm.item.seller.name) + " ")]) : _vm._e(), _vm.item.buyer ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.buyer")) + " " + _vm._s(_vm.item.buyer.name) + " ")]) : _vm._e()]) : _vm._e()], 1)], 2) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }